module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Da-Ea.c7c91fbe.png";